/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Editor_Select_Event_GroupInputs */



/**
* | output |
* | --- |
* | "Select event group {name}" |
*
* @param {Editor_Select_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_select_event_group = /** @type {((inputs: Editor_Select_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Select_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Selectionner le groupe d'evenements ${i?.name}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ereignisgruppe ${i?.name} auswählen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Seleziona il gruppo di eventi ${i?.name}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Выберите группу событий ${i?.name}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Seleccionar grupo de eventos ${i?.name}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`选择事件组${i?.name}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベントグループを選択 ${i?.name}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इवेंट समूह ${i?.name} का चयन करें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Selecione o grupo de eventos ${i?.name}`)
	return /** @type {LocalizedString} */ (`Select event group ${i?.name}`)
});